// @mui
import { Box, BoxProps } from '@mui/material';
// hooks
import { useResponsive } from '@mgm/common/hooks/useResponsive';
import { HEADER, NAV } from '../../data';

const SPACING = 8;

export default function Main({ children, sx, ...other }: BoxProps) {
  const isDesktop = useResponsive('up', 'lg');

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        pt: `${HEADER.H_MAIN_DESKTOP + SPACING}px`,
        pb: 4,
        px: 2,
        ...(isDesktop && {
          pt: `${HEADER.H_MAIN_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
